import { createFileRoute, redirect } from '@tanstack/react-router'

export function redirectToUserLogs() {
  throw redirect({ to: '/logs/user' })
}

export const Route = createFileRoute('/_app/logs/')({
  beforeLoad: redirectToUserLogs,
})
